import { ActionState, ActionStateEnum, IdleConstruction, IdleCreateState, AddEntityState, AddJoineryState, RoomType } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";

import { PlanManager } from "../../../../cocosPlan";
import { Commands, EntityDefaultPropertiesManager, EntityFactory, Events, eventsManager, Listener, math, Room, SavaneConstants, SceneConstants, TemporaryWall, Wall } from "@rhinov/savane-js";

declare var cc: any;

export class AddRoomState extends ActionState {

    state: number = ActionStateEnum.addRoom;
    _sideX: number = 0;
    _sideY: number = 0;
    _begin: math.vec3 | null = null;
    _room: Wall[] | null = null;
    _roomType: number;
    entityEdition: Listener;

    _lastCursorPosition: math.vec3 | null = null;
    _dragging = false;

    testDone = false;


    constructor(roomType: number) {
        super();
        this._roomType = roomType;
        this.entityEdition = new Listener((data: any) => {
            this.changeToEntityEdition(data.userData.entity);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.entityEdition);
    }

    getAction (): number {
        return ActionStateEnum.addRoom;
    }

    getWallRoomAtCorner (point: math.vec3): Wall[] {
        var walls: Wall[] = [];
        if (this._room === null) {
            return walls;
        }
        for (var i = 0; i < this._room.length; i++) {
            if (this._room[i].isCorner(point)) {
                walls.push(this._room[i]);
            }
        }
        return walls;
    }

    mouseClickDown (cursorPosition: math.vec3, doubleClick?: boolean, hoverEntities?: any[], mouseButton?: number): ActionState | null {
        if (mouseButton === 2) {
            PlanManager.getInstance().mouseClickCancelled();
            return null;
        }

        this._dragging = false;
        this._lastCursorPosition = math.vec3.clone(cursorPosition);

        this._begin = math.vec3.create();
        math.vec3.copy(this._begin, cursorPosition);

        return null;
    }

    mouseClickUp (cursorPosition: math.vec3, elapsedTime?: number, hoverEntities?: any[], mouseButton?: number) {
        var i;
        if (this._room !== null) {
            var isValid = true;
            //hack to draw only inside dimension
            for (i = 0; i < this._room.length; i++) {
                var wall = this._room[i];
                wall.deleteRoom(-1);

                if (!wall.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                    isValid = false;
                }

            }

            for (i = 0; i < this._room.length; i++) {
                this._room[i].saveAndEndTemporary();
                PlanManager.getInstance().deleteWall(this._room[i].id);
                this._room[i].parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
            }

            if (isValid) {
                var isB2B = (PlanManager.getInstance().user ? PlanManager.getInstance().user.platforms_id !== 1 : false);
                PlanManager.getInstance().executeCommand(new Commands.AddRoomCommand(this._room, isB2B));
                this._sideX = 0;
                this._sideY = 0;
                this._begin = null;
                this._room = null;
                this.testDone = false;

                return null;
            }


        }
        if (this._dragging) {
            this._sideX = 0;
            this._sideY = 0;
            this._begin = null;
            this._room = null;
            this.testDone = false;
            return new AddRoomState(this._roomType);
        }
        else {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction();
        }
    }

    moveMouseCursor (cursorPosition: math.vec3, hoverEntities?: any[], planpos?: any) {
        super.moveMouseCursor(cursorPosition, hoverEntities, planpos);
        if ((this._lastCursorPosition !== null) && (math.vec3.distance(this._lastCursorPosition, cursorPosition) > SavaneConstants.PositionTolerance)) {
            this._dragging = true;
        }
        else {
            if (this._lastCursorPosition === null) {
                this._dragging = false;
                this._lastCursorPosition = math.vec3.clone(cursorPosition);
            }
        }

        if (this._begin !== null) {

            var sideX = Math.abs(this._begin[0] - cursorPosition[0]);
            var sideY = Math.abs(this._begin[1] - cursorPosition[1]);
            if (sideX > SavaneConstants.PositionTolerance && sideY > SavaneConstants.PositionTolerance) {
                this._sideX = sideX;
                this._sideY = sideY;
                this.createRoom();

                var position = math.vec3.create();
                math.vec3.set(position, (this._begin[0] + cursorPosition[0]) / 2, (this._begin[1] + cursorPosition[1]) / 2, 0);
                this.moveRoom(position);
                this.drawRoom();
            }
        }
        return null;
    }

    mouseClickCancelled (cursorPosition: math.vec3) {
        PlanManager.getInstance().updateItemsSelected([]);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
        return new IdleConstruction();
    }

    keyPressed (keyCode: number, ctrl?: boolean, alt?: boolean) {
        if (keyCode == cc.KEY.escape) {
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction();
        }

        if (keyCode === 84 && !this.testDone) {
            //BENCHMARK
            if (this.benchActionTool.running === false) {
                this.benchActionTool.startBenchmarkSession();
                this.mouseClickDown([5600, 8600]);
            } else if (this.benchActionTool.getTotalTime() > 5000) {
                //BENCHMARK
                var averageValue = this.benchActionTool.stopBenchmarkSession();
                console.log('Average bench value : ' + averageValue + ' ms');
                this.testDone = true;
                this.mouseClickUp([13000, 3000]);
                this._begin = null;
            } else {
                //BENCHMARK
                this.benchActionTool.startBenchStep();

                //Fake room creation
                var position = [13000, 3000];
                this.moveMouseCursor(position);

                //BENCHMARK
                this.benchActionTool.endBenchStep();
            }

        }
        return null;
    }

    onButton (buttonId: number) {
        if (this._room !== null) {
            for (var i = 0; i < this._room.length; i++) {
                PlanManager.getInstance().deleteWall(this._room[i].id);
            }
        }
        return true;
    }

    moveRoom (cursorPosition: math.vec3): void {
        if (!this._room) return;
        for (var i = 0; i < this._room.length; i++) {
            var newBegin = math.vec3.create();
            math.vec3.set(newBegin, this._room[i].begin[0] + cursorPosition[0], this._room[i].begin[1] + cursorPosition[1], 0);
            var newEnd = math.vec3.create();
            math.vec3.set(newEnd, this._room[i].end[0] + cursorPosition[0], this._room[i].end[1] + cursorPosition[1], 0);

            this._room[i].begin = newBegin;
            this._room[i].end = newEnd;
        }
    }

    drawRoom (): void {
        if (!this._room) return;
        for (var i = 0; i < this._room.length; i++) {
            var wall = this._room[i];
            GameObjectManager.drawWall(wall, wall.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!), true, true);
        }
    }

    createRoom () {
        // Clean up previous walls for next update
        if (this._room !== null) {
            for (var i = 0; i < this._room.length; i++) {
                PlanManager.getInstance().deleteWall(this._room[i].id);
            }
        }

        // Create the room entirely
        this._room = [];
        switch (this._roomType) {
            case RoomType.square:
                var point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, -this._sideY / 2, 0);
                var point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));
                break;

            case RoomType.L0:
                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 10, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 10, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 10, -this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 10, -this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, -this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, -this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));
                break;

            case RoomType.L90:
                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 10, this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 10, this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 10, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 10, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));
                break;

            case RoomType.L180:
                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 10, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 10, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 10, this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 10, this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));
                break;

            case RoomType.L270:
                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, -this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, -this._sideX / 2, -this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 10, -this._sideY / 10, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 10, -this._sideY / 10, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 10, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 10, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));

                point1 = math.vec3.create();
                math.vec3.set(point1, this._sideX / 2, -this._sideY / 2, 0);
                point2 = math.vec3.create();
                math.vec3.set(point2, -this._sideX / 2, -this._sideY / 2, 0);
                this._room.push(EntityFactory.getInstance().createWall(point1, point2));
                break;

            default:
                break;
        }

        //hack to draw only inside dimension
        var room = new Room(-1);
        for (var i = 0; i < this._room.length; i++) {
            this._room[i].startTemporary();
            (this._room[i].temporary as TemporaryWall).canBeSuperposed = true;
            PlanManager.getInstance().addWall(this._room[i], false);
            this._room[i].addRoom(room);
            EntityDefaultPropertiesManager.getInstance().convertWallToDefaultProperties(this._room[i]);
            room.addWall(this._room[i]);
        }

        // Assign room height
        room.height = this._room[0].height;
    }

    mouseIdle (cursorPosition: math.vec3, hoverEntities: any[], dt: number): ActionState | null {
        return null;
    }
    snapClick () {
        return new IdleConstruction();
    }

    dispose () {
        eventsManager.instance.removeListener(this.entityEdition);
        if (this._room !== null) {
            for (var i = 0; i < this._room.length; i++) {
                PlanManager.getInstance().deleteWall(this._room[i].id);
            }
        }
    }
    /**
     *
     * Return an array of all rooms points
     *
     * @returns {Array}
     */
    getRoomPoints (): math.vec3[] {
        var roomPoints = [];
        if (this._room !== null) {
            for (var i = 0; i < this._room.length; i++) {
                roomPoints.push(this._room[i].begin);
            }
        }
        return roomPoints;
    }

    get isRoomCreated(): boolean {
        return this._room !== null;
    }

    changeToEntityEdition(entity: any): void {
        var newState = null;
        if (entity !== null) {
            switch (entity.entityType) {
                case SceneConstants.EntityType.WorkTop:
                    return;
                case SceneConstants.EntityType.Wall:
                    EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness = entity.thickness;
                    newState = new IdleCreateState(PlanManager.getInstance().vectorDraw);
                    break;
                case SceneConstants.EntityType.Room:
                    EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness = entity.thickness;
                    newState = new AddRoomState(entity.roomType);
                    break;
                case SceneConstants.EntityType.Joinery:
                    EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(entity);
                    entity.length = PlanManager.getInstance().joineriesLength[entity.joineryType];
                    newState = new AddJoineryState(entity);
                    break;
                default:
                    newState = new AddEntityState((entity as any), undefined);
                    break;
            }
        }
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }
}